import {Issue} from "../domain/entities/issue.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class CreateIssueCommand extends AbstractCommand<Issue> {

    public name: CommandName = CommandName.CREATE_ISSUE;

    public tags = ['entity', 'create', 'issue'];

    constructor(payload: Issue) {
        super('issue', payload.uid, payload);
    }

}